/**
 * Плагин: событие connection:startFrom — запуск режима «связь от узла» (startConnectionFrom).
 */
export default {
	init(modeler, context) {
		const {graph} = context;

		const onConnectionStartFrom = ({nodeId}) => {
			if (nodeId) modeler.startConnectionFrom(nodeId);
		};

		graph.on('connection:startFrom', onConnectionStartFrom);

		return () => graph.off('connection:startFrom', onConnectionStartFrom);
	},
};
